import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';

var applyFacet = function applyFacet(existingAppliedFacets, facetSpec, taxonomyId) {
  //Goal: add one or more facet to the applied facet lists for one or more provided taxonomy. The process to do that is to get to the list of applied facets for each taxonomy provided, then add either the single facet or list of facets passed.
  var newAppliedFacets = _objectSpread2({}, existingAppliedFacets);
  var taxonomiesList = [];
  if (typeof taxonomyId === 'string') {
    taxonomiesList.push(taxonomyId);
  } else {
    taxonomiesList = taxonomyId;
  }
  taxonomiesList.forEach(function (taxonomyId) {
    if (!newAppliedFacets[taxonomyId]) {
      newAppliedFacets[taxonomyId] = {};
    }
    var taxonomyFacets = newAppliedFacets[taxonomyId];
    if (!taxonomyFacets[facetSpec.facetKey]) {
      taxonomyFacets[facetSpec.facetKey] = new Set();
    }
    if (typeof facetSpec.facetValue == 'string') {
      taxonomyFacets[facetSpec.facetKey].add(facetSpec.facetValue);
    } else {
      facetSpec.facetValue.forEach(function (value) {
        taxonomyFacets[facetSpec.facetKey].add(value);
      });
    }
  });
  return newAppliedFacets;
};
var removeFacet = function removeFacet(existingAppliedFacets, facetSpec, taxonomyId) {
  var newAppliedFacets = _objectSpread2({}, existingAppliedFacets);
  var taxonomiesList = [];
  if (typeof taxonomyId === 'string') {
    taxonomiesList.push(taxonomyId);
  } else {
    taxonomiesList = taxonomyId;
  }
  taxonomiesList.forEach(function (taxonomyId) {
    if (newAppliedFacets[taxonomyId] && newAppliedFacets[taxonomyId][facetSpec.facetKey]) {
      if (typeof facetSpec.facetValue == 'string') newAppliedFacets[taxonomyId][facetSpec.facetKey]["delete"](facetSpec.facetValue);else facetSpec.facetValue.forEach(function (value) {
        return newAppliedFacets[taxonomyId][facetSpec.facetKey]["delete"](value);
      });
    }
  });
  return newAppliedFacets;
};

export { applyFacet, removeFacet };
//# sourceMappingURL=SearchContextFacetManipulations.js.map
